import axios from 'axios';
import * as jsonpatch from 'fast-json-patch';

export async function HandleAddLecture(lecture) {
    const url = 'api/exlLectureFront/addLecture/';

    const res = await axios.post(url, lecture).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    data: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                data: null,
            };
        }
    );

    return res;
}

export async function HandlePatchLecture(oldLecture, lecture) {
    const patch = jsonpatch.compare(oldLecture, lecture);
    let newPatch = [];

    patch.forEach((operation) => {
        var op = operation;
        op.oldValue = jsonpatch.getValueByPointer(oldLecture, op.path);

        newPatch.push(op);
    });
    const url = 'api/exlLectureFront/patchLecture/';
    const body = {
        id: oldLecture.id,
        EntityId: oldLecture.id,
        serializedPatch: JSON.stringify(newPatch),


    };
    const res = await axios.put(url, body).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    data: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                data: null,
            };
        }
    );

    return res;
}

export async function GetLectureById(lectureId) {
    const url = 'api/exlLectureFront/getLectureById/';
    const params = {
        lectureId
    }
    const res = await axios.get(url, { params }).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    data: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                data: null,
            };
        }
    );
    return res.data;
}

export async function handleRemoveLecture(lectureId){
    const url = 'api/exlLectureFront/removeLecture/';
    const params = {
        lectureId
    }
    const res = await axios.delete(url, { params }).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    data: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                data: null,
            };
        }
    );
    return res;
}

export async function AddAttendance(bookingId, lectureId) {
    const url = 'api/exlAttendanceFront/addAttendance/';
    const body = {
        bookingId: bookingId,
        lectureId: lectureId,
    }
    const res = await axios.post(url, body).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    data: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                data: null,
            };
        }
    );
    return res;
}

export async function RemoveAttendance(attendanceId) {
    const url = 'api/exlAttendanceFront/removeAttendance/';
    const query = { attendanceId: attendanceId };
    const res = await axios.delete(url, {params: query}).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    data: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                data: null,
            };
        }
    );

    return res;
}


export async function UpdateAllAttendances(lectureId, bookingIds) {
    const url = 'api/exlAttendanceFront/updateAllAttendances/';
    const body = {
        LectureId: lectureId,
        BookingIds: bookingIds
    };

    const res = await axios.post(url, body).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    data: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                data: null,
            };
        }
    );

    return res;
}
